import DayPickerInput from 'react-day-picker/DayPickerInput'
import styled from 'styled-components'

import { DatePickerContainer } from '../styled'

export const DatePickerContainerColumn = styled(DatePickerContainer)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  ${({ centered }) => centered && `align-items: center;`};

  .DayPickerInput-Overlay {
    ${({ showDatePickerAbove }) => showDatePickerAbove && 'transform: translateY(-117%)'}
  }
`

export const StyledDatePickerInput = styled(DayPickerInput)`
  .DayPickerInput {
    width: ${({ theme }) =>
      theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
        ? '340px'
        : '100%'};
  }
`
